import React from 'react';
import { Card, CardBody, CardTitle, CardText } from 'reactstrap';
import logo from "../assets/Photos/डॉ. जगत नारायण.JPG"; // Update with the correct image path

const FacultyHead = () => {
    return (
        <div className="container mt-5 mb-5">
            <Card className="shadow border-0 rounded-4">
                <div className="row g-0">
                    <div className="col-md-4 d-flex align-items-center justify-content-center p-4">
                        <img
                            src={logo}
                            alt="संकाय प्रमुख"
                            className="img-fluid rounded-3 shadow-sm"
                            style={{ maxHeight: '300px', objectFit: 'cover' }}
                        />
                    </div>
                    <div className="col-md-8">
                        <CardBody className="p-4">
                            <CardTitle tag="h4" className="text-center text-primary fw-bold">
                                अधिष्ठाता / संकाय प्रमुख
                            </CardTitle>
                            <CardText className="fs-5">
                                <strong>डॉ. जगत नारायण</strong><br />
                                (साहित्य एवं संस्कृति संकाय)
                            </CardText>
                            <hr />
                            <CardText className="mt-3">
                                <strong>संपर्क:</strong> 99960-41064<br />
                                <strong>ई-मेल:</strong> <a href="mailto:hodsahitya@mvsu.ac.in">hodsahitya@mvsu.ac.in</a><br />
                                <strong>टीक परिसर:</strong><br />
                                महर्षि वाल्मीकि संस्कृत विश्वविद्यालय,<br />
                                कुरुक्षेत्र मार्ग, कैथल (हरियाणा) - 136027
                            </CardText>
                        </CardBody>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default FacultyHead;
